import { notify } from '@p2p/components';

import styles from '../../styles.module.scss';

const Content = ({ openInstruction }: { openInstruction: () => void }) => (
  <div>
    <p className={styles.transfet_notify_text}>
      Если у вас возникли трудности с оплатой, ознакомьтесь с нашей простой{' '}
      <span className={styles.link} onClick={openInstruction}>
        инструкцией
      </span>{' '}
      — она поможет быстро и без ошибок завершить перевод!
    </p>
  </div>
);

const transferTimeNotify = ({ openInstruction }: { openInstruction: () => void }) => {
  notify({
    title: 'Осталось меньше 2-х минут!',
    content: <Content openInstruction={openInstruction} />,
    timer: 5000,
  });
};

export { transferTimeNotify };
